<template>
  <el-dialog
    :title="$t('text.reset_password')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="600px"
    class="edit-roles"
  >
    <div>
      <el-form
        label-width="105px"
        :model="form"
        ref="form"
        :rules="rules"
        label-position="top"
      >
        <el-form-item :label="$t('text.username')" prop="Username">
          <el-input
            v-model="form.Username"
            autocomplete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.password')" prop="Password">
          <el-input
            v-model="form.Password"
            auto-complete="new-password"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('text.confirm_password')"
          prop="ConfirmPassword"
        >
          <el-input
            v-model="form.ConfirmPassword"
            auto-complete="new-password"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        @click="submit()"
        :loading="saveLoading"
        >{{ $t('text.save').toUpperCase() }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      saveLoading: false,
      form: {
        Id: '',
        Username: '',
        Password: '',
        ConfirmPassword: ''
      },
      rules: this.initRules()
    }
  },
  methods: {
    initRules() {
      return {
        Password: [
          {
            required: true,
            message: this.$t('text.please_enter_password'),
            trigger: 'blur'
          },
          { validator: this.checkPassword, trigger: 'blur' }
        ],
        ConfirmPassword: [
          {
            required: true,
            message: this.$t('text.please_enter_password_again'),
            trigger: 'blur'
          },
          { validator: this.checkConfirmPassword, trigger: 'blur' }
        ]
      }
    },
    checkPassword(rule, value, callback) {
      let passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,12}/
      let isValid = passwordreg.test(this.form.Password)
      if (!value) {
        return callback(new Error(this.$t('text.please_enter_password')))
      } else if (value.length < 8 || value.length > 12) {
        return callback(new Error(this.$t('text.password_length_rule')))
      } else if (!isValid) {
        return callback(new Error(this.$t('text.password_rule')))
      } else {
        if (this.form.ConfirmPassword !== '') {
          this.$refs.form.validateField('checkPassword')
        }
        callback()
      }
    },
    checkConfirmPassword(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('text.please_enter_password_again')))
      } else if (value !== this.form.Password) {
        callback(new Error(this.$t('text.password_inconsistent')))
      } else {
        callback()
      }
    },
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.form = {
        Id: '',
        Username: '',
        Password: '',
        ConfirmPassword: ''
      }
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.resetPassword()
        }
      })
    },
    resetPassword() {
      this.saveLoading = true
      ApiService.ResetSecondaryUserPassword({
        Id: this.form.Id,
        Password: this.form.Password
      })
        .then(response => {
          this.saveLoading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.reset_password_successfully')
            })
            this.closeDialog()
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.saveLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
